import { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import {
  TextField,
  TextareaField,
  CheckboxField,
  SpaceSelectField,
  DeliveryTimeField,
  PhoneField,
  ParagraphField,
} from '~fields';

import QRMenuWrapper from '../formik/components/QRMenuWrapper';
import Payer from '../formik/components/Payer';
import SelectWithCountField from '~fields/SelectWithCountField';
import OpenHours from '../formik/components/OpenHours';

import { Gap, FormLabel as Label } from '~ui-kit';

const GoodsTransportForm = ({
  formik: { values, setFieldValue },
  formId,
  transportUnits,
  timeInfo,
}) => {
  const navigate = useNavigate();
  const [fromQRCodeReading, setFromQRCodeReading] = useState(false);
  const [toQRCodeReading, setToQRCodeReading] = useState(false);

  const qrCodeOptions = [
    {
      label: 'Lähtöpiste',
      onRead: data => {
        setFieldValue('isFromHVA', true);
        setFromQRCodeReading(data);
        navigate(-1);
      },
    },
    {
      label: 'Päätepiste',
      onRead: data => {
        setFieldValue('isToHVA', true);
        setToQRCodeReading(data);
        navigate(-1);
      },
    },
  ];

  return (
    <QRMenuWrapper options={qrCodeOptions}>
      <Container>
        <SelectWithCountField
          name="packageType"
          options={transportUnits}
          required
          addLabel="Lisää tavara"
        />
        <Gap height="40px" />
        <Label>Tavarakuljetuksen lähtöpaikka</Label>
        <Gap height="8px" />
        <CheckboxField name="isFromHVA" label="Hyvinvointialueen kohde" />
        <Gap height="12px" />
        {values.isFromHVA ? (
          <SpaceSelectField
            required
            name="fromSpace"
            formId={formId}
            externalQRCodeReading={fromQRCodeReading}
            hideLabel
            disableCollapse
          />
        ) : (
          <TextField
            name="fromAddress"
            fallbackLabel="Osoite"
            rows={5}
            required
          />
        )}
        <Gap height="40px" />
        <Label>Tavarakuljetuksen kohdepaikka</Label>
        <Gap height="8px" />
        <CheckboxField name="isToHVA" label="Hyvinvointialueen kohde" />
        <Gap height="12px" />
        {values.isToHVA ? (
          <SpaceSelectField
            required
            name="toSpace"
            formId={formId}
            externalQRCodeReading={toQRCodeReading}
            hideLabel
            disableCollapse
          />
        ) : (
          <TextField
            name="toAddress"
            fallbackLabel="Osoite"
            rows={5}
            required
          />
        )}
        <Gap height="40px" />
        <ParagraphField name="infoParagraph" />
        <DeliveryTimeField name="deliveryTime" formId={formId} />
        {
          timeInfo && (
            <>
              <Gap height="16px" />
              <OpenHours timeInfo={timeInfo} />
            </>
          ) // Show generic open hours, not tied to DeliveryTime!
        }
        <Gap height="40px" />
        <TextareaField
          fallbackPlaceholder="Tarkennus kuljetukseen tai laskutukseen"
          name="additionalInfo"
          label="Lisätietoa"
          rows={5}
          required
        />
        <Gap height="40px" />
        <PhoneField required label="Puhelinnumero" name="contactPhone" />
        <Gap height="24px" />
        <CheckboxField label="Tartuntavaara" name="infectionRisk" />
        <Gap height="24px" />
        <Payer />
      </Container>
    </QRMenuWrapper>
  );
};

const Container = styled.div``;

export default GoodsTransportForm;
